import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './pages/auth/check-login.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule),
    // canActivate: [LoginGuard],
  },
  {
    path: 'booking-home',
    loadChildren: () => import('./pages/booking/booking-home/booking-home.module').then(m => m.BookingHomePageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'faq',
    loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqPageModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule),
    // canActivate: [LoginGuard],
  },
  {
    path: 'sign-in',
    loadChildren: () => import('./pages/sign-in/sign-in.module').then(m => m.SignInPageModule),
  },
  {
    path: 'competition-filter',
    loadChildren: () => import('./pages/competition/competition-filter/competition-filter.module').then(m => m.CompetitionFilterPageModule),
  },
  {
    path: 'competition-scoring',
    loadChildren: () =>
      import('./pages/competition/competition-scoring/competition-scoring.module').then(m => m.CompetitionScoringPageModule),
    canActivate: [LoginGuard],
  },

  // {
  //   path: 'competition-teams',
  //   loadChildren: () =>
  //     import(
  //       './pages/competition/competition-teams/competition-teams.module'
  //     ).then((m) => m.CompetitionTeamsPageModule),
  //   canActivate: [LoginGuard],
  // },
  {
    path: 'sign-up',
    loadChildren: () => import('./pages/sign-up/sign-up.module').then(m => m.SignUpPageModule),
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule),
    // canActivate: [LoginGuard],
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule),
  },
  {
    path: 'handicap-history',
    loadChildren: () => import('./pages/handicap-history/handicap-history.module').then(m => m.HandicapHistoryPageModule),
    // canActivate: [LoginGuard],
  },
  {
    path: 'help-content',
    loadChildren: () => import('./pages/help-content/help-content.module').then(m => m.HelpContentPageModule),
  },
  {
    path: 'player-list',
    loadChildren: () => import('./pages/modal-screens/player-list/player-list.module').then(m => m.PlayerListPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'country-list',
    loadChildren: () => import('./pages/modal-screens/country-list/country-list.module').then(m => m.CountryListPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'change-password',
    loadChildren: () => import('./pages/change-password/change-password.module').then(m => m.ChangePasswordPageModule),
  },
  {
    path: 'about',
    loadChildren: () => import('./pages/about/about.module').then(m => m.AboutPageModule),
  },
  {
    path: 'feedback',
    loadChildren: () => import('./pages/feedback/feedback.module').then(m => m.FeedbackPageModule),
  },
  {
    path: 'contact-us',
    loadChildren: () => import('./pages/contact-us/contact-us.module').then(m => m.ContactUsPageModule),
  },
  {
    path: 'help-content',
    loadChildren: () => import('./pages/help-content/help-content.module').then(m => m.HelpContentPageModule),
  },
  {
    path: 'change-password',
    loadChildren: () => import('./pages/change-password/change-password.module').then(m => m.ChangePasswordPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'description-modal',
    loadChildren: () =>
      import('./pages/competition/competitions-modal/description-modal/description-modal.module').then(m => m.DescriptionModalPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'rules-modal',
    loadChildren: () => import('./pages/competition/competitions-modal/rules-modal/rules-modal.module').then(m => m.RulesModalPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'courses-modal',
    loadChildren: () =>
      import('./pages/competition/competitions-modal/courses-modal/courses-modal.module').then(m => m.CoursesModalPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'full-info-modal',
    loadChildren: () =>
      import('./pages/competition/competitions-modal/full-info-modal/full-info-modal.module').then(m => m.FullInfoModalPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'booking-calendar',
    loadChildren: () => import('./pages/booking/booking-calendar/booking-calendar.module').then(m => m.BookingCalendarPageModule),
  },
  // {
  //   path: 'booking-chart',
  //   loadChildren: () =>
  //     import('./pages/booking/booking-chart/booking-chart.module').then(
  //       (m) => m.BookingChartPageModule
  //     ),
  // },
  {
    path: 'booking-charts',
    loadChildren: () => import('./pages/booking/booking-charts/booking-charts.module').then(m => m.BookingChartsPageModule),
  },
  {
    path: 'booking-club-list',
    loadChildren: () => import('./pages/booking/booking-club-list/booking-club-list.module').then(m => m.BookingClubListPageModule),
  },
  {
    path: 'booking-detail-modal',
    loadChildren: () =>
      import('./pages/booking/booking-detail-modal/booking-detail-modal.module').then(m => m.BookingDetailModalPageModule),
  },
  {
    path: 'booking-list',
    loadChildren: () => import('./pages/booking/booking-list/booking-list.module').then(m => m.BookingListPageModule),
  },
  {
    path: 'booking-search',
    loadChildren: () => import('./pages/booking/booking-search/booking-search.module').then(m => m.BookingSearchPageModule),
  },
  {
    path: 'by-club',
    loadChildren: () => import('./pages/booking/by-club/by-club.module').then(m => m.ByClubPageModule),
  },
  {
    path: 'caddy-flight-details',
    loadChildren: () =>
      import('./pages/booking/caddy-flight-details/caddy-flight-details.module').then(m => m.CaddyFlightDetailsPageModule),
  },
  {
    path: 'caddy-flight-lists',
    loadChildren: () => import('./pages/booking/caddy-flight-lists/caddy-flight-lists.module').then(m => m.CaddyFlightListsPageModule),
  },
  {
    path: 'chart',
    loadChildren: () => import('./pages/booking/chart/chart.module').then(m => m.ChartPageModule),
  },
  {
    path: 'club-booking-list',
    loadChildren: () => import('./pages/booking/club-booking-list/club-booking-list.module').then(m => m.ClubBookingListPageModule),
  },
  {
    path: 'club-calendar',
    loadChildren: () => import('./pages/booking/club-calendar/club-calendar.module').then(m => m.ClubCalendarPageModule),
  },
  {
    path: 'club-refund-redeem-history',
    loadChildren: () =>
      import('./pages/booking/club-refund-redeem-history/club-refund-redeem-history.module').then(m => m.ClubRefundRedeemHistoryPageModule),
  },
  {
    path: 'flight-buggy-lists',
    loadChildren: () => import('./pages/booking/flight-buggy-lists/flight-buggy-lists.module').then(m => m.FlightBuggyListsPageModule),
  },
  {
    path: 'player-facility-home',
    loadChildren: () =>
      import('./pages/booking/player-facility-home/player-facility-home.module').then(m => m.PlayerFacilityHomePageModule),
  },
  {
    path: 'player-option-modal',
    loadChildren: () => import('./pages/booking/player-option-modal/player-option-modal.module').then(m => m.PlayerOptionModalPageModule),
  },
  {
    path: 'slots-detail',
    loadChildren: () => import('./pages/booking/slots-detail/slots-detail.module').then(m => m.SlotsDetailPageModule),
  },
  {
    path: 'starter-flight-lists',
    loadChildren: () =>
      import('./pages/booking/starter-flight-lists/starter-flight-lists.module').then(m => m.StarterFlightListsPageModule),
  },
  {
    path: 'tee-buggy-list',
    loadChildren: () => import('./pages/booking/tee-buggy-list/tee-buggy-list.module').then(m => m.TeeBuggyListPageModule),
  },
  {
    path: 'tee-flight-lists',
    loadChildren: () => import('./pages/booking/tee-flight-lists/tee-flight-lists.module').then(m => m.TeeFlightListsPageModule),
  },
  {
    path: 'date-and-time',
    loadChildren: () => import('./pages/modal-screens/date-and-time/date-and-time.module').then(m => m.DateAndTimePageModule),
  },
  {
    path: 'scorecard-display',
    loadChildren: () => import('./pages/scorecard-display/scorecard-display.module').then(m => m.ScorecardDisplayPageModule),
  },
  {
    path: 'recent-club',
    loadChildren: () => import('./pages/performance/recent-club/recent-club.module').then(m => m.RecentClubPageModule),
  },
  {
    path: 'handicap-history-details',
    loadChildren: () =>
      import('./pages/handicap-history-details/handicap-history-details.module').then(m => m.HandicapHistoryDetailsPageModule),
  },
  {
    path: 'scorecard-list',
    loadChildren: () => import('./pages/scorecard-list/scorecard-list.module').then(m => m.ScorecardListPageModule),
  },
  {
    path: 'select-courses',
    loadChildren: () => import('./pages/normalgame/select-courses/select-courses.module').then(m => m.SelectCoursesPageModule),
  },
  {
    path: 'flight-setup',
    loadChildren: () => import('./pages/normalgame/flight-setup/flight-setup.module').then(m => m.FlightSetupPageModule),
  },
  {
    path: 'course-box',
    loadChildren: () => import('./pages/modal-screens/course-box/course-box.module').then(m => m.CourseBoxPageModule),
  },
  {
    path: 'course-lists',
    loadChildren: () => import('./pages/normalgame/course-list/course-list.module').then(m => m.CourseListPageModule),
  },
  {
    path: 'search-player-list',
    loadChildren: () => import('./pages/search-player-list/search-player-list.module').then(m => m.SearchPlayerListPageModule),
  },
  {
    path: 'hole-analysis',
    loadChildren: () => import('./pages/hole-analysis/hole-analysis.module').then(m => m.HoleAnalysisPageModule),
  },
  {
    path: 'club-list1',
    loadChildren: () => import('./pages/performance/club-list1/club-list1.module').then(m => m.ClubList1PageModule),
  },
  {
    path: 'course-list',
    loadChildren: () => import('./pages/performance/course-list/course-list.module').then(m => m.CourseListPageModule),
  },
  {
    path: 'event-log',
    loadChildren: () => import('./pages/event-log/event-log.module').then(m => m.EventLogPageModule),
  },
  {
    path: 'new-contact',
    loadChildren: () => import('./pages/new-contact/new-contact.module').then(m => m.NewContactPageModule),
  },
  {
    path: 'friend-list',
    loadChildren: () => import('./pages/friend-list/friend-list.module').then(m => m.FriendListPageModule),
  },
  {
    path: 'setup-player-courses',
    loadChildren: () =>
      import('./pages/normalgame/select-courses/setup-player-courses/setup-player-courses.module').then(
        m => m.SetupPlayerCoursesPageModule
      ),
  },
  {
    path: 'add-player-list',
    loadChildren: () => import('./pages/modal-screens/add-player-list/add-player-list.module').then(m => m.AddPlayerListPageModule),
  },
  {
    path: 'player-groups',
    loadChildren: () => import('./pages/player-groups/player-groups.module').then(m => m.PlayerGroupsPageModule),
  },
  {
    path: 'caddy-details',
    loadChildren: () => import('./pages/modal-screens/caddy-list/caddy-details/caddy-details.module').then(m => m.CaddyDetailsPageModule),
  },
  {
    path: 'caddy-list',
    loadChildren: () => import('./pages/modal-screens/caddy-list/caddy-list.module').then(m => m.CaddyListPageModule),
  },
  {
    path: 'player-address',
    loadChildren: () => import('./pages/modal-screens/player-address/player-address.module').then(m => m.PlayerAddressPageModule),
  },
  {
    path: 'prices-display',
    loadChildren: () => import('./pages/modal-screens/prices-display/prices-display.module').then(m => m.PricesDisplayPageModule),
  },
  {
    path: 'edit-profile',
    loadChildren: () => import('./pages/edit-profile/edit-profile.module').then(m => m.EditProfilePageModule),
  },
  {
    path: 'image-zoom',
    loadChildren: () => import('./pages/modal-screens/image-zoom/image-zoom.module').then(m => m.ImageZoomPageModule),
  },
  {
    path: 'tee-slot-list',
    loadChildren: () => import('./pages/modal-screens/tee-slot-list/tee-slot-list.module').then(m => m.TeeSlotListPageModule),
  },
  {
    path: 'player-voucher',
    loadChildren: () => import('./pages/modal-screens/player-voucher/player-voucher.module').then(m => m.PlayerVoucherPageModule),
  },
  {
    path: 'voucher-list',
    loadChildren: () => import('./pages/modal-screens/voucher-list/voucher-list.module').then(m => m.VoucherListPageModule),
  },
  {
    path: 'redeem-player-club-credits',
    loadChildren: () =>
      import('./pages/modal-screens/redeem-player-club-credits/redeem-player-club-credits.module').then(
        m => m.RedeemPlayerClubCreditsPageModule
      ),
  },
  {
    path: 'buggy-seating',
    loadChildren: () => import('./pages/modal-screens/buggy-seating/buggy-seating.module').then(m => m.BuggySeatingPageModule),
  },
  {
    path: 'gameround-scoring',
    loadChildren: () => import('./pages/gameround-scoring/gameround-scoring.module').then(m => m.GameroundScoringPageModule),
  },
  {
    path: 'friend-list1',
    loadChildren: () => import('./pages/normalgame/friend-list/friend-list.module').then(m => m.FriendListPageModule),
  },
  {
    path: 'tee-box',
    loadChildren: () => import('./pages/modal-screens/tee-box/tee-box.module').then(m => m.TeeBoxPageModule),
  },
  {
    path: 'club-list',
    loadChildren: () => import('./pages/normalgame/club-list/club-list.module').then(m => m.ClubListPageModule),
  },
  {
    path: 'partner-list',
    loadChildren: () => import('./pages/normalgame/partner-list/partner-list.module').then(m => m.PartnerListPageModule),
  },
  {
    path: 'hotel-list',
    loadChildren: () => import('./pages/modal-screens/hotel-list/hotel-list.module').then(m => m.HotelListPageModule),
  },
  {
    path: 'change-course',
    loadChildren: () => import('./pages/normalgame/change-course/change-course.module').then(m => m.ChangeCoursePageModule),
  },
  {
    path: 'scorecard-filter',
    loadChildren: () => import('./pages/scorecard-filter/scorecard-filter.module').then(m => m.ScoreboardFilterPageModule),
  },
  {
    path: 'edit-teeoff',
    loadChildren: () => import('./pages/modal-screens/edit-teeoff/edit-teeoff.module').then(m => m.EditTeeoffPageModule),
  },
  {
    path: 'scorecard-local-list',
    loadChildren: () => import('./pages/scorecard-local-list/scorecard-local-list.module').then(m => m.ScorecardLocalListPageModule),
  },
  {
    path: 'scoring-test',
    loadChildren: () => import('./pages/scoring-test/scoring-test.module').then(m => m.ScoringTestPageModule),
  },
  {
    path: 'modal-competition',
    loadChildren: () => import('./pages/modal-competition/modal-competition.module').then(m => m.ModalCompetitionPageModule),
  },
  {
    path: 'group-booking-option',
    loadChildren: () =>
      import('./pages/modal-screens/group-booking-option/group-booking-option.module').then(m => m.GroupBookingOptionPageModule),
  },
  {
    path: 'refund-booking-players',
    loadChildren: () =>
      import('./pages/modal-screens/refund-booking-players/refund-booking-players.module').then(m => m.RefundBookingPlayersPageModule),
  },

  {
    path: 'manage-discount-card',
    loadChildren: () =>
      import('./pages/modal-screens/manage-discount-card/manage-discount-card.module').then(m => m.ManageDiscountCardPageModule),
  },

  {
    path: 'caddy-schedule-display',
    loadChildren: () =>
      import('./pages/modal-screens/caddy-schedule-display/caddy-schedule-display.module').then(m => m.CaddyScheduleDisplayPageModule),
  },
  {
    path: 'courses-display',
    loadChildren: () => import('./pages/modal-screens/courses-display/courses-display.module').then(m => m.CoursesDisplayPageModule),
  },
  {
    path: 'description-box',
    loadChildren: () => import('./pages/modal-screens/description-box/description-box.module').then(m => m.DescriptionBoxPageModule),
  },

  {
    path: 'select-dates',
    loadChildren: () => import('./pages/modal-screens/select-dates/select-dates.module').then(m => m.SelectDatesPageModule),
  },
  {
    path: 'external-payment',
    loadChildren: () => import('./pages/modal-screens/external-payment/external-payment.module').then(m => m.ExternalPaymentPageModule),
  },
  {
    path: 'test-payment',
    loadChildren: () => import('./pages/modal-screens/test-payment/test-payment.module').then(m => m.TestPaymentPageModule),
  },
  {
    path: 'player-club-handicap',
    loadChildren: () =>
      import('./pages/modal-screens/player-club-handicap/player-club-handicap.module').then(m => m.PlayerClubHandicapPageModule),
  },
  {
    path: 'player-refund-redeem-history',
    loadChildren: () =>
      import('./pages/modal-screens/player-refund-redeem-history/player-refund-redeem-history.module').then(
        m => m.PlayerRefundRedeemHistoryPageModule
      ),
  },
  {
    path: 'player-subscription',
    loadChildren: () =>
      import('./pages/modal-screens/player-subscription/player-subscription.module').then(m => m.PlayerSubscriptionPageModule),
  },

  {
    path: 'ratings-list',
    loadChildren: () => import('./pages/modal-screens/ratings-list/ratings-list.module').then(m => m.RatingsListPageModule),
  },
  {
    path: 'member-menu',
    loadChildren: () => import('./pages/modal-screens/member-menu/member-menu.module').then(m => m.MemberMenuPageModule),
  },
  {
    path: 'club-home',
    loadChildren: () => import('./pages/club/club-home/club-home.module').then(m => m.ClubHomePageModule),
  },
  {
    path: 'hole-googlemap',
    // component: HoleGoogleMapPage
    loadChildren: () => import('./pages/gameround-scoring/hole-googlemap/hole-googlemap.module').then(m => m.HoleGooglemapPageModule),
  },
  {
    path: 'player-favourite-list',
    loadChildren: () => import('./pages/player-favourite-list/player-favourite-list.module').then(m => m.PlayerFavouriteListPageModule),
  },
  {
    path: 'add-location',
    loadChildren: () => import('./pages/add-location/add-location.module').then(m => m.AddLocationPageModule),
  },
  {
    path: 'add-state-list',
    loadChildren: () => import('./pages/add-state-list/add-state-list.module').then(m => m.AddStateListPageModule),
  },
  {
    path: 'add-club-list',
    loadChildren: () => import('./add-club-list/add-club-list.module').then(m => m.AddClubListPageModule),
  },
  {
    path: 'select-scorer',
    loadChildren: () => import('./pages/select-scorer/select-scorer.module').then(m => m.SelectScorerPageModule),
  },
  {
    path: 'caddy-details',
    loadChildren: () => import('./pages/modal-screens/caddy-list/caddy-details/caddy-details.module').then(m => m.CaddyDetailsPageModule),
  },
  {
    path: 'competition-scoring-list',
    loadChildren: () =>
      import('./pages/competition/competition-scoring-list/competition-scoring-list.module').then(m => m.CompetitionScoringListPageModule),
  },
  {
    path: 'club-booking-list',
    loadChildren: () => import('./pages/booking/club-booking-list/club-booking-list.module').then(m => m.ClubBookingListPageModule),
  },
  {
    path: 'booking-details',
    loadChildren: () => import('./pages/booking/booking-details/booking-details.module').then(m => m.BookingDetailsPageModule),
  },
  {
    path: 'packages',
    loadChildren: () => import('./pages/packages/packages.module').then(m => m.PackagesPageModule),
  },
  {
    path: 'add-package',
    loadChildren: () => import('./pages/packages/add-package/add-package.module').then(m => m.AddPackagePageModule),
  },
  {
    path: 'package-details',
    loadChildren: () => import('./pages/packages/package-details/package-details.module').then(m => m.PackageDetailsPageModule),
  },
  {
    path: 'package-booking-details',
    loadChildren: () =>
      import('./pages/package-booking-details/package-booking-details.module').then(m => m.PackageBookingDetailsPageModule),
  },
  {
    path: 'play-option-detail',
    loadChildren: () => import('./pages/packages/play-option-detail/play-option-detail.module').then(m => m.PlayOptionDetailPageModule),
  },
  {
    path: 'stay-option-detail',
    loadChildren: () => import('./pages/packages/stay-option-detail/stay-option-detail.module').then(m => m.StayOptionDetailPageModule),
  },
  {
    path: 'setup-maintenance',
    loadChildren: () => import('./pages/reference-data/setup-maintenance/setup-maintenance.module').then(m => m.SetupMaintenancePageModule),
  },
  {
    path: 'manage-membership',
    loadChildren: () =>
      import('./pages/modal-screens/partner/manage-membership/manage-membership.module').then(m => m.ManageMembershipModule),
  },
  {
    path: 'mapping-details',
    loadChildren: () => import('./pages/externalfinance/mapping-details/mapping-details.module').then(m => m.MappingDetailsPageModule),
  },
  {
    path: 'trxn-picklist',
    loadChildren: () => import('./pages/externalfinance/trxn-picklist/trxn-picklist.module').then(m => m.TrxnPicklistPageModule),
  },
  {
    path: 'initiate-integration',
    loadChildren: () =>
      import('./pages/externalfinance/initiate-integration/initiate-integration.module').then(m => m.InitiateIntegrationPageModule),
  },
  {
    path: 'trxn-order-list',
    loadChildren: () => import('./pages/club/trxn-order-list/trxn-order-list.module').then(m => m.TrxnOrderListPageModule),
  },
  // {
  //   path: 'handicap-membership-add',
  //   loadChildren: () => import('./pages/modal-screens/handicap-membership-add/handicap-membership-add.module').then( m => m.HandicapMembershipAddPageModule)
  // },
  {
    path: 'membership-application-details',
    loadChildren: () =>
      import('./pages/modal-screens/partner/membership-application-details/membership-application-details.module').then(
        m => m.MembershipApplicationDetailsPageModule
      ),
  },
  {
    path: 'club-membership-update',
    loadChildren: () =>
      import('./pages/modal-screens/club-membership-update/club-membership-update.module').then(m => m.ClubMembershipUpdatePageModule),
  },
  {
    path: 'handicap-membership-add',
    loadChildren: () =>
      import('./pages/modal-screens/handicap-membership/handicap-membership-add/handicap-membership-add.module').then(
        m => m.HandicapMembershipAddPageModule
      ),
  },
  {
    path: 'user-list-address',
    loadChildren: () => import('./pages/user-profile/user-list-address/user-list-address.module').then(m => m.UserListAddressPageModule),
  },
  {
    path: 'user-manage-address',
    loadChildren: () =>
      import('./pages/user-profile/user-manage-address/user-manage-address.module').then(m => m.UserManageAddressPageModule),
  },
  {
    path: 'item-list-management',
    loadChildren: () => import('./pages/club/item-list-management/item-list-management.module').then(m => m.ItemListManagementPageModule),
  },
  // {
  //   path: 'trxn-order-details',
  //   loadChildren: () => import('./pages/club/trxn-order-details/trxn-order-details.module').then(m => m.TrxnOrderDetailsPageModule)
  // },
  {
    path: 'initiate-payment',
    loadChildren: () => import('./pages/modal-screens/initiate-payment/initiate-payment.module').then(m => m.InitiatePaymentPageModule),
  },
  {
    path: 'edit-teetime-settings',
    loadChildren: () =>
      import('./pages/modal-screens/edit-teetime-settings/edit-teetime-settings.module').then(m => m.EditTeetimeSettingsPageModule),
  },
  {
    path: 'generate-report',
    loadChildren: () => import('./pages/booking/generate-report/generate-report.module').then(m => m.GenerateReportPageModule),
  },
  {
    path: 'partner-booking-list',
    loadChildren: () =>
      import('./pages/booking/partner-booking-list/partner-booking-list.module').then(m => m.PartnerBookingListPageModule),
  },
  {
    path: 'additional-items-list',
    loadChildren: () =>
      import('./pages/modal-screens/additional-items-list/additional-items-list.module').then(m => m.AdditionalItemsListPageModule),
  },
  {
    path: 'club-payment-transactions',
    loadChildren: () =>
      import('./pages/booking/club-payment-transactions/club-payment-transactions.module').then(m => m.ClubPaymentTransactionsPageModule),
  },
  {
    path: 'outlet-list',
    loadChildren: () => import('./pages/modal-screens/outlet-list/outlet-list.module').then(m => m.OutletListPageModule),
  },
  {
    path: 'instance-picklist',
    loadChildren: () => import('./pages/modal-screens/instance-picklist/instance-picklist.module').then(m => m.InstancePicklistPageModule),
  },
  {
    path: 'club-player-wallet-topup',
    loadChildren: () =>
      import('./pages/modal-screens/club-player-wallet-topup/club-player-wallet-topup.module').then(m => m.ClubPlayerWalletTopupPageModule),
  },
  {
    path: 'player-wallet-history',
    loadChildren: () =>
      import('./pages/modal-screens/player-wallet-history/player-wallet-history.module').then(m => m.PlayerWalletHistoryPageModule),
  },
  {
    path: 'expenditure-type-list',
    loadChildren: () =>
      import('./pages/modal-screens/expenditure-type-list/expenditure-type-list.module').then(m => m.ExpenditureTypeListPageModule),
  },
  {
    path: 'manage-player-card',
    loadChildren: () =>
      import('./pages/modal-screens/manage-player-card/manage-player-card.module').then(m => m.ManagePlayerCardPageModule),
  },
  {
    path: 'display-flight-start',
    loadChildren: () =>
      import('./pages/booking/display-flight-start/display-flight-start.module').then(m => m.DisplayFlightStartPageModule),
  },
  {
    path: 'tee-time-slots',
    loadChildren: () => import('./pages/booking/tee-time-slots/tee-time-slots/tee-time-slots.module').then(m => m.TeeTimeSlotsPageModule),
  },
  {
    path: 'handicap-application-list',
    loadChildren: () =>
      import('./pages/modal-screens/partner/handicap-application-list/handicap-application-list.module').then(
        m => m.HandicapApplicationListPageModule
      ),
  },
  {
    path: 'trxn-order-details',
    loadChildren: () => import('./pages/club/trxn-order-details/trxn-order-details.module').then(m => m.TrxnOrderDetailsPageModule),
  },
  {
    path: 'player-mg2u-credits',
    loadChildren: () =>
      import('./pages/modal-screens/player-mg2u-credits/player-mg2u-credits.module').then(m => m.PlayerMg2uCreditsPageModule),
  },
  {
    path: 'generate-report-list',
    loadChildren: () =>
      import('./pages/modal-screens/generate-report-list/generate-report-list.module').then(m => m.GenerateReportPageModule),
  },
  {
    path: 'package-message',
    loadChildren: () => import('./pages/package-message/package-message.module').then(m => m.PackageMessagePageModule),
  },
  {
    path: 'stay-package-request',
    loadChildren: () => import('./pages/stay-package-request/stay-package-request.module').then(m => m.StayPackageRequestPageModule),
  },
  {
    path: 'scorecard-management',
    loadChildren: () => import('./pages/scorecard-management/scorecard-management.module').then(m => m.ScorecardManagementPageModule),
  },
  {
    path: 'competition-list',
    loadChildren: () => import('./pages/competition/competition-list/competition-list.module').then(m => m.CompetitionListPageModule),
  },
  {
    path: 'agent-mg2u-credits',
    loadChildren: () =>
      import('./pages/modal-screens/agent-mg2u-credits/agent-mg2u-credits.module').then(m => m.AgentMg2uCreditsPageModule),
  },
  {
    path: 'agent-mg2u-history',
    loadChildren: () =>
      import('./pages/modal-screens/agent-refund-redeem-history/agent-refund-redeem-history.module').then(
        m => m.AgentRefundRedeemHistoryPageModule
      ),
  },
  {
    path: 'package-booking-details',
    loadChildren: () =>
      import('./pages/package-booking-details/package-booking-details.module').then(m => m.PackageBookingDetailsPageModule),
  },
  {
    path: 'hotel-list',
    loadChildren: () => import('./pages/modal-screens/hotel-list/hotel-list.module').then(m => m.HotelListPageModule),
  },
  {
    path: 'room-list',
    loadChildren: () => import('./pages/modal-screens/room-list/room-list.module').then(m => m.RoomListPageModule),
  },
  {
    path: 'manage-menus',
    loadChildren: () => import('./pages/manage-menus/manage-menus.module').then(m => m.ManageMenusModule),
  },
  {
    path: 'package-request',
    loadChildren: () => import('./pages/package-request/package-request.module').then(m => m.PackageRequestPageModule),
  },
  {
    path: 'agent-settings',
    loadChildren: () => import('./pages/club/agent-settings/agent-settings.module').then(m => m.AgentSettingsPageModule),
  },
  {
    path: 'agent-list',
    loadChildren: () => import('./pages/club/agent-list/agent-list.module').then(m => m.AgentListPageModule),
  },
  {
    path: 'pricing-plan-list',
    loadChildren: () => import('./pages/modal-screens/pricing-plan-list/pricing-plan-list.module').then(m => m.PricingPlanListPageModule),
  },
  {
    path: 'agent-payment-transactions',
    loadChildren: () =>
      import('./pages/club/agent-payment-transactions/agent-payment-transactions.module').then(m => m.AgentPaymentTransactionsPageModule),
  },
  {
    path: 'agent-statement-list',
    loadChildren: () => import('./pages/club/agent-statement-list/agent-statement-list.module').then(m => m.AgentStatementListPageModule),
  },
  {
    path: 'agent-statements',
    loadChildren: () => import('./pages/club/agent-statements/agent-statements.module').then(m => m.AgentStatementsPageModule),
  },
  {
    path: 'facility-booking-list',
    loadChildren: () =>
      import('./pages/club/facility-booking-list/facility-booking-list.module').then(m => m.FacilityBookingListPageModule),
  },
  {
    path: 'print-report-option',
    loadChildren: () =>
      import('./pages/modal-screens/print-report-option/print-report-option.module').then(m => m.PrintReportOptionPageModule),
  },
  {
    path: 'facility-details',
    loadChildren: () => import('./pages/booking/facility-details/facility-details.module').then(m => m.FacilityDetailsPageModule),
  },
  {
    path: 'agent-balance-update',
    loadChildren: () =>
      import('./pages/modal-screens/agent-balance-update/agent-balance-update.module').then(m => m.AgentBalanceUpdatePageModule),
  },

  {
    path: 'facility-detail',
    loadChildren: () => import('./pages/club/facility-detail/facility-detail.module').then(m => m.FacilityDetailPageModule),
  },
  {
    path: 'facility-status',
    loadChildren: () => import('./pages/club/facility-status/facility-status.module').then(m => m.FacilityStatusPageModule),
  },
  {
    path: 'pos-sales-list',
    loadChildren: () => import('./pages/club/pos-sales-list/pos-sales-list.module').then(m => m.PosSalesListPageModule),
  },
  {
    path: 'course-group-box',
    loadChildren: () => import('./pages/modal-screens/course-group-box/course-group-box.module').then(m => m.CourseGroupBoxPageModule),
  },
  {
    path: 'make-payment',
    loadChildren: () => import('./pages/modal-screens/make-payment-page/make-payment-page.module').then(m => m.MakePaymentPageModule),
  },
  {
    path: 'common-make-payment',
    loadChildren: () =>
      import('./pages/modal-screens/common-make-payment-page/common-make-payment-page.module').then(m => m.CommonMakePaymentPageModule),
  },
  {
    path: 'common-refund-page',
    loadChildren: () =>
      import('./pages/modal-screens/common-refund-page/common-refund-page.module').then(m => m.CommonRefundPageModalModule),
  },
  {
    path: 'facility-management',
    loadChildren: () => import('./pages/club/facility-management/facility-management.module').then(m => m.FacilityManagementPageModule),
  },
  {
    path: 'transaction-type',
    loadChildren: () => import('./pages/reference-data/transaction-type/transaction-type.module').then(m => m.TransactionTypePageModule),
  },
  {
    path: 'product-pricing',
    loadChildren: () => import('./pages/reference-data/product-pricing/product-pricing.module').then(m => m.ProductPricingPageModule),
  },
  {
    path: 'facilities',
    loadChildren: () => import('./pages/reference-data/facilities/facilities.module').then(m => m.FacilitiesPageModule),
  },
  {
    path: 'news',
    loadChildren: () => import('./pages/manage-menus/news/news.module').then(m => m.NewsPageModule),
  },
  {
    path: 'promotion',
    loadChildren: () => import('./pages/manage-menus/promotion/promotion.module').then(m => m.PromotionPageModule),
  },
  {
    path: 'setting',
    loadChildren: () => import('./pages/manage-menus/setting/setting.module').then(m => m.SettingPageModule),
  },
  {
    path: 'hotel-management',
    loadChildren: () => import('./pages/hotel-management/hotel-management.module').then(m => m.HotelManagementPageModule),
  },
  {
    path: 'add-edit-hotel',
    loadChildren: () => import('./pages/hotel-management/add-edit-hotel/add-edit-hotel.module').then(m => m.AddEditHotelPageModule),
  },
  {
    path: 'hotel-detail',
    loadChildren: () => import('./pages/hotel-management/hotel-detail/hotel-detail.module').then(m => m.HotelDetailPageModule),
  },
  {
    path: 'add-edit-hotel-room',
    loadChildren: () =>
      import('./pages/hotel-management/add-edit-hotel-room/add-edit-hotel-room.module').then(m => m.AddEditHotelRoomPageModule),
  },
  {
    path: 'player-facility-type-list',
    loadChildren: () =>
      import('./pages/club/player-facility-type-list/player-facility-type-list.module').then(m => m.PlayerFacilityTypeListPageModule),
  },
  {
    path: 'facility-availablity',
    loadChildren: () => import('./pages/club/facility-availablity/facility-availablity.module').then(m => m.FacilityAvailablityPageModule),
  },

  {
    path: 'facility-booking-details',
    loadChildren: () =>
      import('./pages/club/facility-booking-details/facility-booking-details.module').then(m => m.FacilityBookingDetailsPageModule),
  },
  {
    path: 'facility-payment-selection',
    loadChildren: () =>
      import('./pages/club/facility-payment-selection/facility-payment-selection.module').then(m => m.FacilityPaymentSelectionPageModule),
  },
  {
    path: 'add-edit-agent-associated',
    loadChildren: () =>
      import('./pages/club/agent-settings/add-edit-agent-associated/add-edit-agent-associated.module').then(
        m => m.AddEditAgentAssociatedPageModule
      ),
  },
  {
    path: 'tax-profiles',
    loadChildren: () => import('./pages/reference-data/tax-profiles/tax-profiles.module').then(m => m.TaxProfilesPageModule),
  },
  {
    path: 'club-customer',
    loadChildren: () => import('./pages/reference-data/club-customer/club-customer.module').then(m => m.ClubCustomerPageModule),
  },
  {
    path: 'product-package',
    loadChildren: () => import('./pages/reference-data/product-package/product-package.module').then(m => m.ProductPackagePageModule),
  },
  {
    path: 'paymnet',
    loadChildren: () => import('./pages/reference-data/paymnet/paymnet.module').then(m => m.PaymnetPageModule),
  },
  {
    path: 'product-and-pricing-mapping',
    loadChildren: () =>
      import('./pages/reference-data/product-and-pricing-mapping/product-and-pricing-mapping.module').then(
        m => m.ProductAndPricingMappingPageModule
      ),
  },
  {
    path: 'refund',
    loadChildren: () => import('./pages/reference-data/refund/refund.module').then(m => m.RefundPageModule),
  },
  {
    path: 'pos-code',
    loadChildren: () => import('./pages/reference-data/pos-code/pos-code.module').then(m => m.PosCodePageModule),
  },
  {
    path: 'club-group-user',
    loadChildren: () => import('./pages/reference-data/club-group-user/club-group-user.module').then(m => m.ClubGroupUserPageModule),
  },
  {
    path: 'club-groups',
    loadChildren: () => import('./pages/reference-data/club-groups/club-groups.module').then(m => m.ClubGroupsPageModule),
  },
  {
    path: 'common-modal',
    loadChildren: () => import('./pages/common/common-modal/common-modal.module').then(m => m.CommonModalPageModule),
  },
  {
    path: 'user-home-item-list',
    loadChildren: () =>
      import('./pages/manage-menus/user-home-item/user-home-item-list/user-home-item-list.module').then(m => m.UserHomeItemListPageModule),
  },
  {
    path: 'user-home-item-details',
    loadChildren: () =>
      import('./pages/manage-menus/user-home-item/user-home-item-details/user-home-item-details.module').then(
        m => m.UserHomeItemDetailsPageModule
      ),
  },
  {
    path: 'user-list',
    loadChildren: () => import('./pages/user-profile/user-list/user-list.module').then(m => m.UserListPageModule),
  },
  {
    path: 'news-list',
    loadChildren: () => import('./pages/modal-screens/news/news-list/news-list.component').then(m => m.NewsListComponent),
  },
  {
    path: 'news-details',
    loadChildren: () => import('./pages/modal-screens/news/news-details/news-details.module').then(m => m.NewsDetailsModule),
  },
  {
    path: 'user-club-outlet-type-list',
    loadChildren: () =>
      import('./pages/manage-menus/user-club-outlet-type/user-club-outlet-type-list/user-club-outlet-type-list.module').then(
        m => m.UserClubOutletTypeListPageModule
      ),
  },
  {
    path: 'user-club-outlet-type-details',
    loadChildren: () =>
      import('./pages/manage-menus/user-club-outlet-type/user-club-outlet-type-details/user-club-outlet-type-details.module').then(
        m => m.UserClubOutletTypeDetailsPageModule
      ),
  },
  {
    path: 'club-outlet-type-list',
    loadChildren: () =>
      import('./pages/manage-menus/club-outlet-type/club-outlet-type-list/club-outlet-type-list.module').then(
        m => m.ClubOutletTypeListPageModule
      ),
  },
  {
    path: 'club-outlet-type-details',
    loadChildren: () =>
      import('./pages/manage-menus/club-outlet-type/club-outlet-type-details/club-outlet-type-details.module').then(
        m => m.ClubOutletTypeDetailsPageModule
      ),
  },
  {
    path: 'edit-items',
    loadChildren: () => import('./pages/club/edit-items/edit-items.module').then(m => m.EditItemsPageModule),
  },
  {
    path: 'caddy-availablity',
    loadChildren: () =>
      import('./pages/modal-screens/caddy-list/caddy-availablity/caddy-availablity.module').then(m => m.CaddyAvailablityPageModule),
  },
  {
    path: 'pending-booking-list',
    loadChildren: () =>
      import('./pages/booking/pending-booking-list/pending-booking-list.module').then(m => m.AgreementPartnerBookingListPageModule),
  },
  {
    path: 'view-bookings-list',
    loadChildren: () =>
      import('./pages/common/view-bookings-container/view-bookings-container.module').then(m => m.ViewBookingsContainerPageModule),
  },
  {
    path: 'messaging-page',
    loadChildren: () =>
      import('./pages/modal-screens/messaging/messaging-details/messaging-details.module').then(m => m.MessagingDetailsPageModule),
  },
  {
    path: 'flight-schedule-display',
    loadChildren: () =>
      import('./pages/modal-screens/flight-schedule-display/flight-schedule-display.module').then(m => m.FlightScheduleDisplayPageModule),
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
